module.exports = "/images/first-time-homebuyer-background.png?e0f1e6130741a3bca78e3ec3f59aa4d3";